import { createApi } from '@reduxjs/toolkit/query/react';
import { getHeaders } from 'auth/auth';
import { baseQueryWithReauth } from '../baseQuery';

export const activityLogAPI = createApi({
  reducerPath: 'activityLogAPI',
  tagTypes: ['ActivityLogs'],
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    listActivityLogs: builder.query({
      query: ({
        skip = 0,
        limit = 50,
        entity_type,
        entity_id,
        user_id,
        action,
        start_date,
        end_date,
        loan_application_id,
        borrower_id,
        search,
      } = {}) => {
        const params = new URLSearchParams({
          skip: String(skip),
          limit: String(limit),
        });

        if (entity_type) params.append('entity_type', entity_type);
        if (entity_id) params.append('entity_id', entity_id);
        if (user_id) params.append('user_id', user_id);
        if (action) params.append('action', action);
        if (start_date) params.append('start_date', start_date);
        if (end_date) params.append('end_date', end_date);
        if (loan_application_id)
          params.append('loan_application_id', loan_application_id);
        if (borrower_id) params.append('borrower_id', borrower_id);
        if (search) params.append('search', search);

        return {
          url: `/b2b/activity-logs?${params.toString()}`,
          method: 'GET',
          headers: getHeaders(),
        };
      },
      providesTags: ['ActivityLogs'],
    }),
  }),
});

export const {
  useListActivityLogsQuery,
  // Lazy variant used by the Export CSV button on the loan-level modal —
  // we don't want the "give me every row" query to fire on modal mount,
  // only when the user clicks Export.
  useLazyListActivityLogsQuery,
} = activityLogAPI;
